import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const FormPlaceholder = ( { onClickAction }: any) => {
    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
             <Box>
                <Typography variant="h3" textAlign={'center'}>
                    You've not selected a process
                </Typography>
                    <Typography variant="subtitle1" textAlign={'center'}>
                        Click on a process to select, or <Typography
                        sx={{ cursor: 'pointer' }}
                        display={'inline'}
                        fontWeight={'bold'}
                        color={'primary'}
                        variant="subtitle1"
                        onClick={() => {
                            onClickAction()
                        }}
                    >add new</Typography> now
                </Typography>
            </Box>
        </Box>
    )
}

export default FormPlaceholder;